import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShortcutShift = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "5 5 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99997 5.89246L6.27563 10.0331H8.40383V14.1076H11.5961V10.0331H13.7243L9.99997 5.89246Z",
		stroke: "currentColor"
	})
});
export default SvgShortcutShift;
